<template>
  <View gap="sm" direction="column">
    <View gap="md" direction="row" justify="space-between" padding-block="sm">
      <Text variant="h3">Activity feed</Text>
    </View>

    <View v-if="isPending" justify="center" padding-block="lg">
      <LoadingIndicator />
    </View>

    <Text v-else-if="items.length === 0" variant="body-medium" color="tertiary">
      Activity for this property will appear here.
    </Text>

    <ActivityFeedList v-else :items="items" />
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { LoadingIndicator, Text, View } from '@tallo/design-system';
import { ActivityFeedList, usePropertyActivityFeedQuery } from '@tallo/investor/activity-feed';

const props = defineProps<{ limit?: number }>();

const { data, isPending } = usePropertyActivityFeedQuery();
const allItems = computed(() => data.value || []);
const items = computed(() => (props.limit ? allItems.value.slice(0, props.limit) : allItems.value));
</script>
